import { z } from "zod";

export const dashboardFiltersSchema = z.object({
  heatLevel: z
    .enum(["frozen", "cold", "cool", "warm", "hot", "burning"])
    .optional(),
  status: z.enum(["negotiating", "won", "lost", "cancelled"]).optional(),
  dateRange: z
    .object({
      start: z.date().optional(),
      end: z.date().optional(),
    })
    .optional(),
});

export type DashboardFilters = z.infer<typeof dashboardFiltersSchema>;
